@if (control) {
    <div fxLayout="column" fxLayoutAlign="start start" [ngClass]="widthClass">
        <div class="t5 c-primary-gray-600">{{ (label || 'i18n_af_labelPhone') | translate }} {{ this.isRequired ? '*' : '' }}</div>
        <div #popoverAnchor class="w-100 mt-4">
            <mat-form-field class="w-100"
                            [class.value-not-empty]="control.valid">
                <input matInput
                       type="phoneNumber"
                       [formControl]="control"
                       inputmode="numeric"
                       autocomplete="do-not-autofill"
                       prefix="+"
                       [validation]="false"
                       [mask]="selectedCountryCode?.phoneMask"
                       [placeholder]="'i18n_af_placeholderPhone' | translate"
                       name="phoneNumber"/>
                <div matPrefix fxLayout="row" fxLayoutAlign="start center"
                     class="ml-16"
                     uiKitClickOutside
                     (clickOutside)="popover.close()"
                     (click)="control.enabled && popover.open()">
                    @if (selectedCountryCode?.isoCode) {
                        <ui-kit-svg class="i-24"
                                    [name]="'ic_flag_' + selectedCountryCode?.isoCode | lowercase"/>
                    }
                    <ui-kit-spinner [spinnerIds]="spinnerId"
                                    class="ml-4"
                                    [diameter]="16"
                                    [strokeWidth]="3"/>
                    @if (!Spinner.isShown(spinnerId)) {
                        <ui-kit-svg class="i-16 ml-4" name="ic_arrow_down"/>
                    }
                </div>
                @if (control.hasError('required')) {
                    <mat-error
                        class="c-secondary-red-900">
                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                    </mat-error>
                }
                @if (control.hasError('mask')) {
                    <mat-error
                        class="c-secondary-red-900">
                        {{ 'i18n_af_fieldValidationPhonePattern' | translate }}
                    </mat-error>
                }
            </mat-form-field>
            <sat-popover #popover [anchor]="popoverAnchor" verticalAlign="below" horizontalAlign="start">
                <div class="phone-popover-container" fxLayout="column" fxLayoutAlign="start start">
                    @for (phone of filteredPhones; track phone) {
                        <div
                            class="item"
                            [class.selected]="phone.isoCode === selectedCountryCode?.isoCode"
                            (click)="onCountryCodeSelected(phone)">
                            <div>{{ phone.prefix }}</div>
                            <div class="ml-8">
                                {{ phone.countryName | firstLetterCapitalized }}
                            </div>
                        </div>
                    }
                </div>
            </sat-popover>
        </div>
    </div>
}
